export default __webpack_public_path__ + "static/raiser-64a2855466cb485a4a7c41610ec4ea8e.svg";